import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import { Paragraph, Text } from 'components/core/Typography';

import './Amenities.scss';

export default function Amenities({ amenities }) {
	return (
		<div className="amenities-lists">
			{map(amenities, (group) => (
				<div
					className="amenities-group"
					key={group.label}
				>
					<Paragraph
						last
						size="small"
					>
						{group.label}
					</Paragraph>
					<ul>
						{map(
							group.items,
							(item) =>
								!!item.hasAttribute && (
									<li
										className="amenities-group-list-item"
										key={item.label}
									>
										<Text>{item.label}</Text>
									</li>
								),
						)}
					</ul>
				</div>
			))}
		</div>
	);
}

Amenities.propTypes = {
	amenities: PropTypes.object,
};
